var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrello({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.25 368.59c0 11.506-9.04 20.546-20.545 20.546h-85.47c-11.506 0-20.546-9.04-20.546-20.545V114.645c0-11.505 9.04-20.546 20.545-20.546h85.47c11.506 0 20.546 9.04 20.546 20.546v253.946zM417.49 251.89c0 11.506-9.04 20.547-19.724 20.547h-86.292c-11.506 0-20.546-9.04-20.546-20.546V114.645c0-11.505 9.04-20.546 20.546-20.546h85.47c11.506 0 20.546 9.04 20.546 20.546v137.246z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3 40.6H7.8C3.7 40.6.4 43.9.4 48v47.6c0 4.1 3.3 7.4 7.4 7.4h47.5c4.1 0 7.4-3.3 7.4-7.4V48c0-4.1-3.3-7.4-7.4-7.4zM27.2 85.5c0 1.4-1.1 2.5-2.5 2.5H14.3c-1.4 0-2.5-1.1-2.5-2.5V54.6c0-1.4 1.1-2.5 2.5-2.5h10.4c1.4 0 2.5 1.1 2.5 2.5v30.9zm24-14.2c0 1.4-1.1 2.5-2.4 2.5H38.3c-1.4 0-2.5-1.1-2.5-2.5V54.6c0-1.4 1.1-2.5 2.5-2.5h10.4c1.4 0 2.5 1.1 2.5 2.5v16.7z",
    fill: "url(#prefix___Linear1)",
    fillRule: "nonzero",
    transform: "translate(-3.287 -334.074) scale(8.2183)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix___Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -62.39 62.39 0 31.545 103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0052cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrello);
export default __webpack_public_path__ + "static/media/Trello.8b2a3a5cf455bf03cc5cbdae7b60b08b.svg";
export { ForwardRef as ReactComponent };